'use strict';

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      Object.defineProperty(target, descriptor.key, descriptor);
    }
  }

  return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);
    if (staticProps) defineProperties(Constructor, staticProps);
    return Constructor;
  };
}();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

var _autoBind = require('../utils/autoBind');

var _autoBind2 = _interopRequireDefault(_autoBind);

var _noop = require('../utils/noop');

var _noop2 = _interopRequireDefault(_noop);

var _AutoComplete = require('../AutoComplete/AutoComplete');

var _AutoComplete2 = _interopRequireDefault(_AutoComplete);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _possibleConstructorReturn(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return call && (_typeof(call) === "object" || typeof call === "function") ? call : self;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + _typeof(superClass));
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });
  if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}

var InputRange = function (_Component) {
  _inherits(InputRange, _Component);

  function InputRange(props) {
    _classCallCheck(this, InputRange);

    var _this = _possibleConstructorReturn(this, (InputRange.__proto__ || Object.getPrototypeOf(InputRange)).call(this, props));

    _this.state = {};
    (0, _autoBind2["default"])(['onSelect'], _this);
    return _this;
  }

  _createClass(InputRange, [{
    key: 'onSelect',
    value: function onSelect(name, selected) {
      this.props.onSelect(name, selected);
    }
  }, {
    key: 'render',
    value: function render() {
      var _props = this.props,
          name = _props.name,
          disabled = _props.disabled,
          suggestions = _props.suggestions,
          placeholders = _props.placeholders;
      var mainClass = (0, _classnames2["default"])('react-filters', 'rf-input-range', name, {
        disabled: disabled
      });
      return _react2["default"].createElement('div', {
        className: mainClass
      }, _react2["default"].createElement(_AutoComplete2["default"], {
        keys: ['author', 'title'],
        list: suggestions[0],
        name: 'ir-lower',
        onSelect: this.onSelect,
        placeholder: placeholders[0]
      }), _react2["default"].createElement('span', {
        className: 'ir-separator'
      }, ' - '), _react2["default"].createElement(_AutoComplete2["default"], {
        keys: ['author', 'title'],
        list: suggestions[1],
        name: 'ir-upper',
        onSelect: this.onSelect,
        placeholder: placeholders[1]
      }));
    }
  }]);

  return InputRange;
}(_react.Component);

exports["default"] = InputRange;
InputRange.propTypes = {
  disabled: _react.PropTypes.bool,
  name: _react.PropTypes.string,
  onSelect: _react.PropTypes.func.isRequired,
  placeholders: _react.PropTypes.arrayOf(_react.PropTypes.string),
  suggestions: _react.PropTypes.array
};
InputRange.defaultProps = {
  disabled: false,
  onSelect: _noop2["default"]
};